<template>
  <router-view />
</template>

<script src="https://kit.fontawesome.com/0b6ab23626.js" crossorigin="anonymous"></script>
<script>
import './styles/styles.scss'

export default {
  name: 'App',
  data: () => ({
    //
  })
}
</script>
